import { environment } from '../../../environments/environment';

// Definición de variables de configuración Globales
export const CONFIG = {
    WS_END_POINT: environment.apiRest,

    CREDENCIALES: btoa('angularapp' + ':' + '123456'),

    LANGUAGE: 'es',

    HTTPHEADERSJSON: { 'Content-Type': 'application/json' },

    ERRORSTATUS0: 'Error de conexión con BackEnd',

    WELCOME_PAGE: ['/inicio'],

    LOGIN_PAGE: ['/seguridad/login'],

    IDLE_TIME: 3000, //en segundos 25: 1500
    IDLE_TIME_OUT: 300, //en segundos 5: 300
    PULL_TIME: 3360, // en segundos 35: 2100

    COLOR_SCHEME: {
        domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA'],
    },
};
